/**
 * @file
 * Contains helper methods for the Time select elements.
 */

const TimeInputHelper = {
  processSecondsToTimeSelection: function (seconds, use24Hour = true) {
    if (seconds > 0) {
      let meridian = "AM";
      let fromTime = seconds / 60 / 60;
      let minFloat = fromTime % 1;
      minFloat = (minFloat * 60).toFixed(0);
      fromTime = Math.trunc(fromTime);
      if (use24Hour) {
        fromTime = fromTime >= 10 ? fromTime : "0" + fromTime;
      } else {
        if (fromTime > 12) {
          fromTime -= 12;
          meridian = "PM";
        }
        if (fromTime === 0) {
          fromTime = 12;
        }
      }
      minFloat = minFloat >= 59 ? 59 : minFloat;
      minFloat = minFloat >= 10 ? minFloat : "0" + minFloat;
      minFloat = minFloat === "0" ? "00" : minFloat;
      fromTime += ":" + minFloat;
      if (!use24Hour) {
        fromTime += " " + meridian;
      }
      return fromTime;
    }
    return use24Hour ? "00:00" : "Midnight";
  },
};

export default TimeInputHelper;
